import { styled } from "@mui/material/styles";

export const LoadingContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
}));
